"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PricingResponse = exports.PricingItem = exports.CustomFee = exports.PropertyPricing = exports.PropertyCharge = void 0;
var PropertyCharge = /** @class */ (function () {
    function PropertyCharge() {
        this.arCodeId = '';
        this.arCodeName = '';
        this.arCodeDescription = '';
        this.arCodeMarketDescription = '';
        this.arCodeGroupId = null;
        this.arCodeGroupName = '';
        this.arTriggerId = '';
        this.arTriggerName = '';
        this.rateIntervalStart = '';
        this.arOriginId = '';
        this.arOriginName = '';
        this.arOriginReferenceId = '';
        this.arOriginObjectId = null;
        this.rateAmount = '';
        this.advertisedFrequencyAmount = '';
        this.isIncludedInCachedRates = '';
        this.isDeposit = false;
    }
    return PropertyCharge;
}());
exports.PropertyCharge = PropertyCharge;
var PropertyPricing = /** @class */ (function () {
    function PropertyPricing() {
        this.baseRent = '';
        this.totalMonthlyLeasingPrice = '';
        this.totalDeposit = '';
    }
    return PropertyPricing;
}());
exports.PropertyPricing = PropertyPricing;
var CustomFee = /** @class */ (function () {
    function CustomFee() {
        this.id = '';
        this.name = '';
        this.description = '';
        this.arCodeMarketDescription = '';
        this.arTriggerId = '';
        this.arTriggerName = '';
        this.amountType = '';
        this.amountDetail = null;
        this.fixedAmount = null;
        this.avgAmount = null;
        this.maxAmount = null;
        this.minAmount = null;
        this.isOptional = '';
        this.rateIntervalStart = '';
        this.feeType = '';
        this.timing = '';
        this.frequency = '';
        this.method = '';
    }
    return CustomFee;
}());
exports.CustomFee = CustomFee;
var PricingItem = /** @class */ (function () {
    function PricingItem() {
        this.propertyCharges = {};
        this.property = new PropertyPricing();
        this.customFees = [];
        this.rentPriceIncludeLabel = '';
        this.totalMonthlyLeasingPrice = '';
        this.marketRent = '';
        this.totalDeposit = '';
    }
    return PricingItem;
}());
exports.PricingItem = PricingItem;
var PricingResponse = /** @class */ (function () {
    function PricingResponse() {
        this.pricingItems = [];
    }
    return PricingResponse;
}());
exports.PricingResponse = PricingResponse;
